<app-marine-insurance-card [cardTitle]="'INSURED_VALUE_AND_COMMODITY'" [isCanEdit]="true" (edit)="edit.emit()">
  <ng-container body>
    <div class="marine-insurance-quote-value-commodity-body">
      <div class="row">
        <div class="col-12 col-xl-6">
          <app-marine-insurance-quote-view-data
            [marineInsurance]="marineInsurance"
            [isShowDepartureDate]="false"
          ></app-marine-insurance-quote-view-data>
        </div>
      </div>
    </div>

    <div class="marine-insurance-quote-value-commodity-footer">
      <app-control-wrapper [control]="formGroup.get('goodsTypeDescription')" [errors]="errors" [isShowHelper]="false">
        <label for="goodsTypeDescription" control-label>{{ "MARINE_INSURANCE_DESCRIPTION_LABEL" | translate }}</label>
        <textarea
          class="form-control"
          id="goodsTypeDescription"
          name="goodsTypeDescription"
          rows="2"
          control-wrapper
          [formControl]="formGroup.get('goodsTypeDescription')"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [placeholder]="'MARINE_INSURANCE_DESCRIPTION_HINT' | translate"
        ></textarea>
      </app-control-wrapper>
    </div>
  </ng-container>
</app-marine-insurance-card>
